import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=3b8bd0cc&scoped=true&"
import script from "./LoginAs.vue?vue&type=script&lang=js&"
export * from "./LoginAs.vue?vue&type=script&lang=js&"
import style0 from "./LoginAs.vue?vue&type=style&index=0&id=3b8bd0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8bd0cc",
  null
  
)

export default component.exports